// @flow
import * as React from 'react'
import {
  Button,
  Typography,
  Descriptions,
  Skeleton,
  Row,
  Col,
  Modal,
} from 'antd'
import {
  Twitter,
  Facebook,
  Mail,
  Linkedin,
  Telegram,
  Whatsapp,
} from 'react-social-sharing'
import cheerio from 'cheerio'
import { injectIntl } from 'react-intl'
import { fetchEventDetails } from '../../utils/apiFetch'
import EventDetailsHeader from '../EventDetailsHeader'
import './index.css'

const { Title, Paragraph } = Typography

type EventDetailsProps = {
  event: Event,
  backFn: () => void,
  intl: any,
}

type EventDetailsState = {
  image: ?string,
  descrizione: ?string,
  mapsLink: ?string,
  eventURL: ?string,
  loading: boolean,
  sharingOpen: boolean,
}

class EventDetails extends React.Component<
  EventDetailsProps,
  EventDetailsState,
> {
  state = {
    image: null,
    descrizione: null,
    mapsLink: null,
    eventURL: null,
    loading: true,
    sharingOpen: false,
  }

  parseDescription = html => {
    const $ = cheerio.load(html)
    const mapsLink = $('a[href*="maps.google.com"]')
    if (mapsLink && mapsLink.parent().is('div')) mapsLink.parent().remove()
    else if (mapsLink) mapsLink.remove()

    const parsedDOM = {
      descrizione: $('body').html(),
      mapsLink: mapsLink ? mapsLink.attr('href') : null,
    }

    return parsedDOM
  }

  componentDidMount() {
    fetchEventDetails(this.props.event.UID).then(rawData => {
      const image = rawData.evento.img._cdata.replace(
        'leadImage_mobiledetails',
        'leadImage',
      )
      const eventURL = image.replace(/leadImage/, '')

      this.setState({
        image,
        eventURL,
        ...this.parseDescription(rawData.evento.descrizione._cdata),
        loading: false,
      })
    })
  }

  toggleSharing = () =>
    this.setState(prevState => ({
      sharingOpen: !prevState.sharingOpen,
    }))

  render() {
    const {
      image,
      descrizione,
      mapsLink,
      eventURL,
      loading,
      sharingOpen,
    } = this.state
    const { title, date, location, image: imageSmall, UID } = this.props.event
    const { intl } = this.props

    return (
      <div className="event-details" id={`event${UID}`}>
        <EventDetailsHeader
          title={title}
          uid={UID}
          image={image}
          imageSmall={imageSmall}
          backFn={this.props.backFn}
        />
        <div className="event-details-content">
          <Title level={2}>{title}</Title>
          <Descriptions>
            <Descriptions.Item>
              {location}, {date}
            </Descriptions.Item>
          </Descriptions>
          <Skeleton loading={loading} active>
            <Row gutter={16}>
              {mapsLink && (
                <Col span={12}>
                  <Button
                    type="primary"
                    icon="environment"
                    style={{ width: '100%' }}
                    href={mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {intl.formatMessage({
                      id: 'eventdetail.mapslink',
                      defaultMessage: 'Google Maps',
                    })}
                  </Button>
                </Col>
              )}
              <Col
                span={12}
                offset={mapsLink ? 0 : 12}
                style={{ textAlign: 'right' }}
              >
                <Button
                  type="primary"
                  icon="share-alt"
                  style={{ width: '100%' }}
                  onClick={this.toggleSharing}
                >
                  {intl.formatMessage({
                    id: 'eventdetail.share',
                    defaultMessage: 'Share',
                  })}
                </Button>
                <Modal
                  className="share-modal"
                  centered
                  onCancel={this.toggleSharing}
                  onOk={this.toggleSharing}
                  visible={sharingOpen}
                  footer={false}
                  title={intl.formatMessage({
                    id: 'eventdetail.share',
                    defaultMessage: 'Share',
                  })}
                >
                  <Whatsapp
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                  <Telegram
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                  <Mail
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                  <Facebook
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                  <Linkedin
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                  <Twitter
                    link={eventURL}
                    label={serviceName =>
                      intl.formatMessage(
                        {
                          id: 'share_label',
                          defaultMessage: `Share on ${serviceName}`,
                        },
                        { serviceName },
                      )
                    }
                  />
                </Modal>
              </Col>
            </Row>
            <Paragraph style={{ marginTop: '2rem' }}>
              <div dangerouslySetInnerHTML={{ __html: descrizione }} />
            </Paragraph>
          </Skeleton>
        </div>
      </div>
    )
  }
}

export default injectIntl(EventDetails)
